// extracted by mini-css-extract-plugin
export default {"section14__draw":"BgLine14--section14__draw--0jln8","path__draw__1":"BgLine14--path__draw__1--It7ab"};